import { render } from "./WaterFall.vue?vue&type=template&id=ba060fc0"
import script from "./WaterFall.vue?vue&type=script&lang=js"
export * from "./WaterFall.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vueworkspace\\h5web\\2023.03.13-掌阅瀑布流vue版\\zy-Client-Code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__